<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright"><em>Hillsdale College Press</em><br/>33 East College Street<br/>Hillsdale, Michigan 49242<br/>www.hillsdale.edu</p>
<p class="copyright"><em>Winston S. Churchill: World in Torment, 1916–1922 (Volume IV)</em><br/>Copyright © 1975 C &amp; T Publications Limited</p>
<p class="copyright">Originally published in 1975 by William Heinemann Ltd. in Great Britain and by Houghton Mifflin in the United States.</p>
<p class="copyright">All rights reserved. eBook edition published 2015 by Hillsdale College Press and RosettaBooks<br/>Cover art by Jirka Väätäinen (based on photograph from the Imperial War Museum, 28 October 1918)<br/>Cover design by Jay McNair<br/>ISBN e-Pub edition: 9780795344541</p>
<p class="copyright">www.RosettaBooks.com</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cop.vue?0854b9fa